// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {useContext, useState} from 'react';
import {useLocation} from 'react-router-dom';
import hopt from 'hola_opt';
// @ts-ignore
import {App_context} from '../../context';
import {use_scrolled} from '../../ui_utils';

interface i_nav_opt {
    transparent?: boolean | number;
    logo?: string;
    logo_to?: string;
    img_url_fn?: (img:string)=>string;
    login_icon_mobile?: boolean;
    logo_and_login?: boolean;
    nologin?: boolean;
    login_text?: string;
    download_svc?: boolean;
}

const r_or_call = (v, default_value?)=>{
    if (v===undefined && default_value!==undefined)
        return default_value;
    if (typeof v=='function')
        return v();
    return v;
};

type fieldval_or_call <T> = {
    [K in keyof T]: T[K] | (()=>T[K]);
}

export type t_navbar_route_fields = {
    headlogo?: boolean;
    headless?: boolean;
    nomenu?: boolean;
    cp_link?: string;
    cp_after_login?: boolean;
    cp_always_icon?: boolean;
    no_getstarted?: boolean;
    with_cart?: boolean;
    nologin?: boolean;
    nav_opt?: i_nav_opt;
}

export type t_navbar_route = fieldval_or_call<t_navbar_route_fields>;

export type use_navbar_props = {
    is_portal?: boolean;
    user_country?: string;
    route?: t_navbar_route;
    nav_opt?: i_nav_opt;
    route_opt?: t_navbar_route_fields;
    ref?: {
        top_portal_ref?: React.RefObject<HTMLDivElement>;
        navbar_portal_ref?: React.RefObject<HTMLDivElement>;
    };
}

const gameboost_paths = ['/game_boost', '/empty/game_boost'];

export const use_navbar = (props: use_navbar_props)=>{
    const {route, user_country, is_portal} = props;
    const geo_blocked = hopt.user_geo_blocked?.blocked;
    const {pathname} = useLocation();
    // @ts-ignore
    const {is_client, is_plus, user, has_ext} = useContext(App_context);
    const {y} = use_scrolled();
    const app_route_opt = props.route_opt || {};
    const [opened, set_opened] = useState(false);
    const headlogo: boolean = route && r_or_call(route.headlogo,
        app_route_opt.headlogo);
    const headless: boolean = route && r_or_call(route.headless,
        app_route_opt.headless);
    const nomenu: boolean = route && r_or_call(route.nomenu,
        app_route_opt.nomenu);
    const cp_link: string = route && r_or_call(route.cp_link,
        app_route_opt.cp_link);
    const cp_after_login: boolean = route && r_or_call(route.cp_after_login,
        app_route_opt.cp_after_login);
    const cp_always_icon: boolean = route && r_or_call(route.cp_always_icon,
        app_route_opt.cp_always_icon);
    const no_getstarted: boolean = route && r_or_call(route.no_getstarted,
        app_route_opt.no_getstarted);
    const with_cart: boolean = route && r_or_call(route.with_cart,
        app_route_opt.with_cart);
    const is_gameboost_page = gameboost_paths.includes(pathname);
    const nav_opt: i_nav_opt = Object.assign(route && r_or_call(route.nav_opt)
        || {}, props.nav_opt || {},
        is_gameboost_page && !props.nav_opt?.logo
            ? {logo: 'logo/gameboost_header.svg'} : {});
    const nologin: boolean = geo_blocked || route && r_or_call(route.nologin,
        app_route_opt.nologin) || !!nav_opt?.nologin;
    const toggle = (state?: boolean)=>{
        if (state === undefined)
            set_opened(v=>!v);
        else
            set_opened(state);
    };
    return {is_client, is_plus, is_scrolled: y > 0, has_user: !!user, opened,
        user_country, headlogo, has_ext, headless, is_portal, nomenu, nologin,
        nav_opt, toggle, no_getstarted, cp_link, cp_after_login, with_cart,
        cp_always_icon};
};
